/**
 * @fileoverview
 * Details Card Component - Display details in a card format with label-value pairs
 * Migrated to new architecture with OnPush change detection
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface DetailsCardItem {
  label: string;
  value: string | number | null | undefined;
}

@Component({
  selector: 'app-details-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './details-card.component.html',
  styleUrl: './details-card.component.css',
})
export class DetailsCardComponent {
  @Input() title: string = 'Details';
  @Input() items: DetailsCardItem[] = [];
}
